import { render } from "./TogglePrimary.vue?vue&type=template&id=6f797dee&scoped=true"
import script from "./TogglePrimary.vue?vue&type=script&lang=js"
export * from "./TogglePrimary.vue?vue&type=script&lang=js"

import "./TogglePrimary.vue?vue&type=style&index=0&id=6f797dee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f797dee"]])

export default __exports__